// extracted by mini-css-extract-plugin
export default {"table":"table_table__NRLne","td":"table_td__aiquY","justify_text":"table_justify_text__D7hJ2","isEdit":"table_isEdit__1DtdB"};